/**
 * CaptainAmerica.js
 * The Captain America Hero class
 */

import { Game } from "pixi_core";
import { Hero } from "./Hero";
import {
    CAPTAIN_AMERICA_SHIELD_FADE_TIME,
    CAPTAIN_AMERICA_SHIELD_SCALE_FINAL,
    CAPTAIN_AMERICA_SHIELD_SCALE_UP,
    DEFAULT_CAPTAIN_AMERICA_DAMAGE_REDUCTION,
    DEFAULT_CAPTAIN_AMERICA_DURATION,
    GameEvents
} from "../Constants";

export class CaptainAmerica extends Hero {
    /**
     * @public
     * @param {Object} heroData
     */
    constructor(heroData) {
        super(heroData);

        /** @private @type {Number} */
        this._abilityDuration = Game.utils.assertNumber(heroData.AbilityDuration, DEFAULT_CAPTAIN_AMERICA_DURATION);

        /** @private @type {Number} */
        this._abilityDamageReduction = Game.utils.assertNumber(heroData.AbilityDamageReduction, DEFAULT_CAPTAIN_AMERICA_DAMAGE_REDUCTION);

        /** @private @type {Number} */
        this._shieldAppearDisappearTime = Game.utils.assertNumber(heroData.ShieldAppearDisappearTime, CAPTAIN_AMERICA_SHIELD_FADE_TIME);

        /** @private @type {Number} */
        this._shieldStartSize = Game.utils.assertNumber(heroData.ShieldStartSize, CAPTAIN_AMERICA_SHIELD_SCALE_UP);

        /** @private @type {Number} */
        this._shieldFinalSize = Game.utils.assertNumber(heroData.ShieldFinalSize, CAPTAIN_AMERICA_SHIELD_SCALE_FINAL);
    }

    /**
     * @public
     * @override
     */
    useAbility() {
        super.useAbility();
        let options = {
            abilityDuration: this._abilityDuration,
            damageReduction: this._abilityDamageReduction,
            shieldAppearDisappearTime: this._shieldAppearDisappearTime,
            shieldStartSize: this._shieldStartSize,
            shieldFinalSize: this._shieldFinalSize
        };
        Game.fire(GameEvents.eHERO_ABILITY_CAPTAIN_AMERICA, options);
    }
}
